// Utilitário centralizado de logs de desenvolvimento.
// Emite logs apenas quando `import.meta.env.DEV === true` ou quando `VITE_ENABLE_UI_LOGS==='true'`.
// Evita repetição de condicionais e risco de esquecer a proteção em novos logs.

function isDevEnabled(): boolean {
  const viteDev = import.meta?.env?.DEV === true;
  const flag = String(import.meta?.env?.VITE_ENABLE_UI_LOGS ?? 'false').toLowerCase() === 'true';
  // Permitir habilitação dinâmica em produção:
  // - Query param: ?uiLogs=true | ?logs=1
  // - localStorage: VITE_ENABLE_UI_LOGS='true'
  let runtime = false;
  if (typeof window !== 'undefined') {
    const qs = new URLSearchParams(window.location?.search || '');
    const qpUi = String(qs.get('uiLogs') || qs.get('logs') || '').toLowerCase();
    runtime = (qpUi === 'true' || qpUi === '1');
    const ls = String(window.localStorage?.getItem?.('VITE_ENABLE_UI_LOGS') || '').toLowerCase();
    runtime = runtime || (ls === 'true');
  }
  return viteDev || flag || runtime;
}

export function devLog(...args: unknown[]): void {
  if (!isDevEnabled()) return;
  console.log(...args);
}

export function devWarn(...args: unknown[]): void {
  if (!isDevEnabled()) return;
  console.warn(...args);
}

export function devError(...args: unknown[]): void {
  if (!isDevEnabled()) return;
  console.error(...args);
}

export function devInfo(...args: unknown[]): void {
  if (!isDevEnabled()) return;
  console.info?.(...args);
}

export function devDebug(...args: unknown[]): void {
  if (!isDevEnabled()) return;
  console.debug?.(...args);
}

export function devGroup(label: string): void {
  if (!isDevEnabled()) return;
  console.group?.(label);
}

export function devGroupCollapsed(label: string): void {
  if (!isDevEnabled()) return;
  console.groupCollapsed?.(label);
}

export function devGroupEnd(): void {
  if (!isDevEnabled()) return;
  console.groupEnd?.();
}
